/// <amd-module name="SuiteCommerce.FeaturedCategory.Item.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Item.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemModel = void 0;
    var ItemModel = /** @class */ (function (_super) {
        __extends(ItemModel, _super);
        function ItemModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ItemModel.prototype, "displayName", {
            get: function () {
                return this.get('storedisplayname2') || this.get('displayname') || this.get('itemid') || '';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "urlComponent", {
            get: function () {
                return this.get('urlcomponent');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "internalId", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "itemImagesDetail", {
            get: function () {
                return this.get('itemimages_detail');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "matrixChildItemsDetail", {
            get: function () {
                return this.get('matrixchilditems_detail');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "priceLevel1Formatted", {
            get: function () {
                return this.get('pricelevel1_formatted');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "onlineCustomerPriceDetail", {
            get: function () {
                return this.get('onlinecustomerprice_detail');
            },
            enumerable: false,
            configurable: true
        });
        return ItemModel;
    }(Backbone_1.Model));
    exports.ItemModel = ItemModel;
});
